import { Card, Table, Layout, Input, message, Button } from "antd";
import Sidebar from "../layout/sidebar";
import { useState, useEffect } from "react";
import api from "../api/api";
import CrearEbook from "./CrearEbook";
import { useNavigate } from "react-router-dom";
import SincronizarEbooks from "./SincronizaEbooks";

const { Content } = Layout;

export default function Ebooks() {
  const [ebooks, setEbooks] = useState([]);
  const [filteredEbooks, setFilteredEbooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    fetchEbooks();
  }, []);

  /* ===================== LOAD EBOOKS ===================== */
  const fetchEbooks = async () => {
    setLoading(true);
    try {
      const res = await api.get("/api/GetEbooks");
      setEbooks(res.data);
      setFilteredEbooks(res.data);
    } catch (error) {
      message.error("No se pudo cargar el catálogo de eBooks");
    } finally {
      setLoading(false);
    }
  };

  /* ===================== SEARCH ===================== */
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = ebooks.filter((ebook) =>
      `${ebook.id} ${ebook.normaEbook} ${ebook.idNormaProveedor}`
        .toLowerCase()
        .includes(value.toLowerCase()),
    );

    setFilteredEbooks(filtered);
  };

  /* ===================== TABLE COLUMNS ===================== */
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      width: 100,
    },
    {
      title: "Norma",
      dataIndex: "normaEbook",
      key: "normaEbook",
    },
    {
      title: "Id Norma Proveedor",
      dataIndex: "idNormaProveedor",
      key: "idNormaProveedor",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout style={{ marginLeft: 200, padding: 20 }}>
        <Content>
          <Card
            title="Catálogo eBooks"
            style={{ minHeight: "80vh", overflowX: "auto" }}
          >
            {/* ===================== SEARCH INPUT ===================== */}
            <Input.Search
              placeholder="Buscar por id, norma o proveedor..."
              allowClear
              size="large"
              style={{ marginBottom: 16, maxWidth: 420 }}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              type="primary"
              onClick={() => navigate("/dashboard/ebook/crearEbook")}
            >
              Agregar Ebook
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={() => navigate("/dashboard/ebook/cargaNorma")}
            >
              Cargar Normas Masivo
            </Button>
            <SincronizarEbooks />
            {/* ===================== TABLE ===================== */}
            <Table
              dataSource={filteredEbooks}
              columns={columns}
              loading={loading}
              rowKey="id"
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50"],
              }}
            />
          </Card>
        </Content>
      </Layout>
    </Layout>
  );
}
